document.addEventListener('DOMContentLoaded', function() {
      
        const swiper = new Swiper('.testimonials', {
      			  
			loop: true,
			pagination: false,
			autoplay: {
				delay: 2500
			},
			slidesPerView: 1,
			speed: 1000,
			slidesPerGroup: 1,
			effect: 'fade',
			  fadeEffect: {
				crossFade: true
			  }		  
			
		});	
});	